export default __webpack_public_path__ + "static/media/165.2a96dbfc.png";